export const bankList = [
    "Axis Bank Ltd.",
    "Bandhan Bank Ltd.",
    "CSB Bank Limited",
    "City Union Bank Ltd.",
    "DCB Bank Ltd.",
    "Dhanlaxmi Bank Ltd.",
    "Federal Bank Ltd.",
    "HDFC Bank Ltd",
    "ICICI Bank Ltd.",
    "IndusInd Bank Ltd",
    "IDFC FIRST Bank Limited",
    "Jammu & Kashmir Bank Ltd.",
    "JILA SAHAKARI KENDRIYA BANK MARYADIT, Durg(C.G.)",
    "Karnataka Bank Ltd.",
    "Karur Vysya Bank Ltd.",
    "Kotak Mahindra Bank Ltd",
    "Nainital bank Ltd.",
    "RBL Bank Ltd.",
    "South Indian Bank Ltd.",
    "Tamilnad Mercantile Bank Ltd.",
    "YES Bank Ltd.",
    "IDBI Bank Limited",
    "Coastal Local Area Bank Ltd",
    "Krishna Bhima Samruddhi LAB Ltd",
    "Subhadra Local Bank Ltd",
    "Au Small Finance Bank Ltd.",
    "Capital Small Finance Bank Ltd",
    "Fincare Small Finance Bank Ltd.",
    "Equitas Small Finance Bank Ltd",
    "ESAF Small Finance Bank Ltd.",
    "Suryoday Small Finance Bank Ltd.",
    "Ujjivan Small Finance Bank Ltd.",
    "Utkarsh Small Finance Bank Ltd.",
    "North East Small finance Bank Ltd",
    "Jana Small Finance Bank Ltd",
    "Shivalik Small Finance Bank Ltd",
    "Unity Small Finance Bank Ltd",
    "Airtel Payments Bank Ltd",
    "India Post Payments Bank Ltd",
    "FINO Payments Bank Ltd",
    "Paytm Payments Bank Ltd",
    "Jio Payments Bank Ltd",
    "NSDL Payments Bank Limited",
    "Bank of Baroda",
    "Bank of India",
    "Bank of Maharashtra",
    "Canara Bank",
    "Central Bank of India",
    "Indian Bank",
    "Indian Overseas Bank",
    "Punjab & Sind Bank",
    "Punjab National Bank",
    "State Bank of India",
    "UCO Bank",
    "Union Bank of India",
    "National Bank for Agriculture and Rural Development",
    "Export - Import Bank of India",
    "National Housing Bank",
    "Small Industries Development Bank of India",
    "Assam Gramin Vikash Bank",
    "Andhra Pradesh Grameena Vikas Bank",
    "Andhra Pragathi Grameena Bank",
    "Arunachal Pradesh Rural Bank",
    "Aryavart Bank",
    "Bangiya Gramin Vikash Bank",
    "Baroda Gujarat Gramin Bank",
    "Baroda Rajasthan Kshetriya Gramin Bank",
    "Baroda UP Bank",
    "Chaitanya Godavari GB",
    "Chhattisgarh Rajya Gramin Bank",
    "Dakshin Bihar Gramin Bank",
    "Ellaquai Dehati Bank",
    "Himachal Pradesh Gramin Bank",
    "J & K Grameen Bank",
    "Jharkhand Rajya Gramin Bank",
    "Karnataka Gramin Bank",
    "Karnataka Vikas Gramin Bank",
    "Kerala Gramin Bank",
    "Madhya Pradesh Gramin Bank",
    "Madhyanchal Gramin Bank",
    "Maharashtra Gramin Bank",
    "Manipur Rural Bank",
    "Meghalaya Rural Bank",
    "Mizoram Rural Bank",
    "Nagaland Rural Bank",
    "Odisha Gramya Bank",
    "Paschim Banga Gramin Bank",
    "Prathama U.P.Gramin Bank",
    "Puduvai Bharathiar Grama Bank",
    "Punjab Gramin Bank",
    "Rajasthan Marudhara Gramin Bank",
    "Saptagiri Grameena Bank",
    "Sarva Haryana Gramin Bank",
    "Saurashtra Gramin Bank",
    "Tamil Nadu Grama Bank",
    "Telangana Grameena Bank",
    "Tripura Gramin Bank",
    "Uttar Bihar Gramin Bank",
    "Utkal Grameen Bank",
    "Uttarbanga Kshetriya Gramin Bank",
    "Vidharbha Konkan Gramin Bank",
    "Uttarakhand Gramin Bank",
    "Australia and New Zealand Banking Group Ltd.",
    "National Australia Bank",
    "Westpac Banking Corporation",
    "Bank of Bahrain & Kuwait BSC",
    "AB Bank Ltd.",
    "Sonali Bank Ltd.",
    "Bank of Nova Scotia",
    "Industrial & Commercial Bank of China Ltd.",
    "BNP Paribas",
    "Credit Agricole Corporate & Investment Bank",
    "Societe Generale",
    "The Ludhiana Central Cooperative Bank Limited",
    "Deutsche Bank",
    "HSBC Ltd",
    "PT Bank Maybank Indonesia TBK",
    "Mizuho Bank Ltd.",
    "Sumitomo Mitsui Banking Corporation",
    "MUFG Bank, Ltd.",
    "Cooperatieve Rabobank U.A.",
    "Doha Bank",
    "Qatar National Bank SAQ",
    "JSC VTB Bank",
    "Sberbank",
    "DBS Bank Ltd.",
    "United Overseas Bank Ltd.",
    "FirstRand Bank Ltd.",
    "Shinhan Bank",
    "Woori Bank",
    "KEB Hana Bank",
    "Industrial Bank of Korea",
    "Bank of Ceylon",
    "Credit Suisse A.G",
    "CTBC Bank Co., Ltd.",
    "Krung Thai Bank Public Co.Ltd.",
    "Abu Dhabi Commercial Bank Ltd.",
    "Mashreq Bank PSC",
    "First Abu Dhabi Bank PJSC",
    "Emirates NBD Bank PJSC",
    "Barclays Bank Plc.",
    "Standard Chartered Bank",
    "NatWest Markets plc",
    "American Express Banking Corp.",
    "Bank of America",
    "Citibank N.A.",
    "J.P.Morgan Chase Bank N.A."
]